import { MainTable } from '../components/table';
import axios from "axios";
import { useContext } from 'react';
import Grid from '@material-ui/core/Grid';
import { Card } from '@material-ui/core';
import { rowData, managersList } from '../components/table/types';
import { usePrizePicksProjections } from 'registerations/hooks/prizePicksProjections';
import { Loader } from 'components/loader';
import { makeStyles } from '@material-ui/core';


const useStyles = makeStyles((theme) => ({
  root: {
    maxHeight: '100vh',
    height: '100vh',
    background: 'linear-gradient(140deg, rgb(209,208,206) 0%, rgb(240,240,241) 100%)',
    padding: 40,
    boxSizing: 'border-box',
    '@media (max-width: 950px)' : {
      padding: theme.spacing(2),
      },     
  }
}));

export const AppContainer = () => {

  const { projections, loading: loadingProjections, projectionError } = usePrizePicksProjections();

  const classes = useStyles();


  if(loadingProjections){
    return(
      <Loader/>
    );

  }

  return (
    <Grid
      container
      className={classes.root}
      spacing={2}

    >
      <Grid item xs={12}>
        <Card variant="outlined">
          <MainTable
            title="Applications"
            rows={projections?.registrations ?? []}
            managersList={projections?.registrations_users ?? []}
          />
          </Card>
      </Grid>
    </Grid>
  );
}

